export default "__VITE_ASSET__a96131c5__"